var React = require('react');

function Mention (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21 12a3.5 3.5 0 0 1-5.909 2.539A4 4 0 1 1 14 8.535V8h2v4a1.5 1.5 0 0 0 3 0a7 7 0 1 0-3.392 6h3.1A9 9 0 1 1 21 12zm-9 2a2 2 0 1 0 0-4a2 2 0 0 0 0 4z","key":0}),React.createElement("rect",{"x":"0","y":"0","width":"24","height":"24","fill":"rgba(0, 0, 0, 0)","key":1})]);
}

Mention.defaultProps = {"width":"24","height":"24","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 24 24","style":{"msTransform":"rotate(360deg)","WebkitTransform":"rotate(360deg)","transform":"rotate(360deg)"}};

module.exports = Mention;

Mention.default = Mention;
